import React from "react";
import { ExternalLink } from "lucide-react";
const ProjectCard = ({ name, link, about, features }) => {
	// Split features string into an array for listing
	const featureList = features.split(", ").map((feature) => feature.trim());

	return (
		<div className="max-w-sm rounded-lg overflow-hidden shadow-lg bg-white hover:bg-gray-100 transition duration-300 ease-in-out">
			<div className="p-6">
				<h2 className="text-2xl font-semibold text-gray-800 mb-4">{name}</h2>
				<p className="text-gray-600 text-base mb-4">{about}</p>

				<div className="bg-blue-100 text-blue-800 rounded-lg p-4 mb-4">
					<p className="text-sm font-medium mb-2">Features:</p>
					<ul className="space-y-1">
						{featureList.map((feature, index) => (
							<li key={index} className="text-sm flex items-start">
								<span className="mr-2 text-blue-600">•</span>
								{feature}
							</li>
						))}
					</ul>
				</div>

				<a
					href={link}
					target="_blank"
					rel="noopener noreferrer"
					className="text-blue-500 hover:text-blue-700 text-sm flex items-center"
				>
					Visit Project
					<ExternalLink className="ml-2" />
				</a>
			</div>
		</div>
	);
};

const ProjectList = () => {
	const projects = [
		{
			name: "DevTinder",
			link: "https://devtinder-web-soqo.onrender.com",
			about: "A Tinder-like app for Developers to connect with each other",
			features:
				"MERN based fullstack project, DaisyUI, User Feed, User Connections",
		},
		{
			name: "NetflixGPT",
			link: "https://netflix-gpt-2ky1.onrender.com",
			about:
				"A Netflix-like App that uses AI search with gemini and TMDB API to show trending movies",
			features: "Firebase, TMDB API, AI enabled search, Responsive Design",
		},
		{
			name: "Quiz App",
			link: "https://quiz-app-frontend-gzfq.onrender.com/",
			about:
				"A Fullstack Quiz App where user can select topics to get quizzed from.",
			features: "MERN, Custom Auth, Custom Middleware, Mongoose ODM",
		},
		{
			name: "Youtube Clone",
			link: "https://namaste-youtube-plit.onrender.com",
			about: "A partial youtube clone",
			features:
				"Search API debouncing and caching, Live chat like implementation, N-level nested comments",
		},
		{
			name: "QuizBingo",
			link: "https://quizingogame.onrender.com/",
			about: "A Quiz Game in a Bingo Game. It's a gamified learning app.",
			features:
				"Redux Toolkit, Save/Load to/from Local Storage, Responsive Design",
		},
		{
			name: "Swiggy Clone",
			link: "https://namaste-react-80wh.onrender.com",
			about: "Swiggy partial clone. This project is my introduction to react",
			features: "Cart system, Swiggy API used to load restaurants data",
		},
	];

	return (
		<div className="flex justify-center">
			<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
				{projects.map((project, index) => (
					<ProjectCard
						key={index}
						name={project.name}
						link={project.link}
						about={project.about}
						features={project.features}
					/>
				))}
			</div>
		</div>
	);
};

export default ProjectList;
